export const imageExtensions = '.png,.jpeg,.jpg,.tif,.tiff,.heic,.heif';
export const imageAndPdfExtensions = '.png,.jpeg,.jpg,.pdf,.tif,.tiff,.heic,.heif';
export const imageMovieAndPdfExtensions = '.png,.jpeg,.jpg,.pdf,.tif,.tiff,.heic,.heif,.mp4,.mov';
export const imagePdfAndDocExtensions = '.png,.jpeg,.jpg,.pdf,.tif,.tiff,.heic,.heif,.doc,.docx';
export const pdfExtensions = '.pdf';

const contactsAndEvaluationsFileExtensions =
    '.png,.jpeg,.jpg,.pdf,.tif,.tiff,.heic,.heif,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.mp4,.mov';
export const pilotFileExtensions = contactsAndEvaluationsFileExtensions;
export const osaseFileExtensions = contactsAndEvaluationsFileExtensions;
export const contactFileExtensions = contactsAndEvaluationsFileExtensions;
